export const EMOTE_SLOT_OVERLAY_ELEMENT_KIND = "emote_slots.slot" as const;
